import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import BasicInput from '@empiriecom/module-components/FormControls/Input/BasicInput';
import useConfig from '../../hooks/useConfig';
import IntlProvider from './IntlProvider';
var InputEmail = function (_a) {
    var onChange = _a.onChange, companyId = _a.companyId, _b = _a.id, id = _b === void 0 ? 'id-email' : _b, _c = _a.name, name = _c === void 0 ? 'email-address' : _c, onValid = _a.onValid, onError = _a.onError;
    var config = useConfig();
    var intl = useIntl();
    var InputEmailTexts = defineMessages({
        label: {
            id: 'form.email.label',
            defaultMessage: '',
        },
        placeholder: {
            id: 'form.email.placeholder',
            defaultMessage: '',
        },
    });
    var emailValidationRules = [
        {
            required: true,
            error: {
                id: 'form.submit.email',
            },
        },
        {
            regEx: config.regExp.eMail.checkAt,
            error: {
                id: 'form.email.error',
            },
        },
        {
            regEx: config.regExp.eMail.checkProvider,
            error: {
                id: 'form.email.errorProvider',
            },
        },
    ];
    return (React.createElement(IntlProvider, { companyId: companyId },
        React.createElement(BasicInput, { id: id, "data-testid": id, name: name, type: "email", label: intl.formatMessage(InputEmailTexts.label), placeholder: intl.formatMessage(InputEmailTexts.placeholder), onChange: function (event) {
                if (onChange) {
                    onChange(event);
                }
            }, onError: onError, onValid: onValid, validationRules: emailValidationRules })));
};
export default InputEmail;
//# sourceMappingURL=index.js.map